  import axios from "axios";
  import qs from "qs";
const mixin = {
  data() {
    return{
      careList:[],
      first_soft:99,
      token:''
    }
  },
  created() {
	if(localStorage.getItem('token')){
		setTimeout(()=>{
			this.getcareList()
		},500)
	}
  },
  methods:{
    isCare(uid) {
      // console.log("object 1:>> ", uid);
      let arr = this.careList.filter((item) => item.uid == uid);
      if (arr && arr.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    // 关注主播
    guanzhu(val, state) {
      console.log("object :>> ", val);
      this.token = localStorage.getItem("token");
      if (state) {
        axios({
          headers: {
            device: "iOS",
            packageId: "1",
            version: "1.0.0",
            "authToken": this.token,
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              //在请求之前对data传参进行格式转换
              data = qs.stringify(data);
              console.log(data);
              return data;
            },
          ],
          url: this.api + "/v1/relation/follow",
          method: "post",
          data: {
            actionUid: val.uid,
          },
        }).then((res) => {
          this.$message({
            message: "关注成功",
            type: "success",
          });
          this.getcareList(2);
          console.log("关注主播", res);
        });
      } else {
        this.$confirm("取关该主播将无法及时收到消息, 是否取关?", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            axios({
              headers: {
                device: "iOS",
                packageId: "1",
                version: "1.0.0",
                "authToken": this.token,
                "Content-Type": "application/x-www-form-urlencoded",
              },
              transformRequest: [
                function(data) {
                  //在请求之前对data传参进行格式转换
                  data = qs.stringify(data);
                  console.log(data);
                  return data;
                },
              ],
              url: this.api + "/v1/relation/unfollow",
              method: "post",
              data: {
                actionUid: val.uid,
              },
            }).then((res) => {
              console.log(res);
              this.$message({
                message: "取关成功",
                type: "success",
              });
              // 判断是分类列表还是 关注列表
              if (this.first_soft == 99) {
                this.getcare();
              } else {
                this.getcareList(2);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 获取关注列表
    async getcareList(type=1) {
      this.token = localStorage.getItem("token");
      if (this.token){
        let list = await this.$store.dispatch('getUserFollowData',type);
        this.careList = list;
      }
    },
  }
}



export default mixin;



// WEBPACK FOOTER //
// ./src/pages/template/mixins/mixinCare.js